/* eslint-disable no-unused-vars */
import * as React from 'react';
import moment from 'moment';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import { ReactComponent as DeleteIcon } from '../assets/img/icons/delete.svg';
import { isValidURL } from '../helpers/Utils';
import { cdnUrl } from '../constants/defaultValues';
import FileViewer from './FileViewer';


function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}

export default function DocTabel(props) {
  const { application,callBackDelete } = props;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const columns = [
    { id: 'docType', label: 'Type', align: 'left', minWidth: 170 },
    { id: 'docNo', label: 'Document Name', minWidth: 100 },
    { id: 'docPassword', label: 'Document Password', minWidth: 100 },
    { id: 'file', label: 'File', maxWidth: 100, maxHeight: 100 },
    { id: 'createdAt', label: 'Created Date', minWidth: 100 },
    { id: 'action', label: 'Action', minWidth: 100 },
  ];

  const myData = application.map((item) => ({
    docType: item.doc_type ? item.doc_type.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') : 'NA',
    docNo: item.doc_no ? item.doc_no : 'NA',
    docPassword: item.doc_password ? item.doc_password : 'NA',
    file: item.file ? (<a href={item.isFromServer ? item.file : cdnUrl + item.file} download target='_blank' rel="noreferrer" > <FileViewer item={item} /> </a>) : 'NA',

    createdAt: item.date_created ? moment(item.date_created).format('DD/MM/YYYY hh:mm A') : 'NA',
    // status: !item.status ? 'PENDING' : item.status,
    action: (
      <div className="mt-2">
        <Button
          variant="outlined" color="error"
          size="sm"
          onClick={() => handleDelete(item)}
        >
          <DeleteIcon className="deactivateIcon " />
        </Button>
      </div>
    ),
  }));
  const handleDelete = (item) => { 
    callBackDelete(item.id)
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {myData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.label} align={column.align}>
                          {column.id === 'action' ? (
                            value
                          ) : (
                            column.format && typeof value === 'number' ? (
                              column.format(value)
                            ) : (
                              value
                            )
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={myData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}